import { apiClient, getBaseUrl, getIdToken } from ".";

export interface ProjectSecurityPolicy {
    projectId: string;
    mode: "optional" | "mfa_required";
    version: number;
    updatedBy?: string;
    updatedAt?: string;
}

export interface ProjectSecurityPolicyResponse {
    policy: ProjectSecurityPolicy;
    etag?: string;
}

async function request<T>(method: "get" | "put", projectId: string, data?: unknown) {
    const idToken = getIdToken();
    const response = await apiClient.request({
        method,
        url: `${getBaseUrl()}/ms-project/projects/${projectId}/security-policy`,
        data,
        headers: idToken ? { Authorization: `Bearer ${idToken}` } : {}
    });
    return { policy: response.data, etag: response.headers.etag } as T;
}

// Kept outside the generated project SDK until the new policy endpoint lands there.
export const projectSecurityApi = {
    get: (projectId: string) => request<ProjectSecurityPolicyResponse>("get", projectId),
    // The version goes in the body: behind the load balancer an If-Match header fails every successful write with 412
    update: (projectId: string, mode: ProjectSecurityPolicy["mode"], version: number) =>
        request<ProjectSecurityPolicyResponse>("put", projectId, { mode, version })
};
